export const parseResponseData = (input) => {
    const output = JSON.parse(JSON.stringify(input)) // Deep copy to avoid mutation

    const widgets = output.widgets

    // Find the "faq" and "upload_rx" widgets
    const faqWidget = widgets.find((widget) => widget.type === "faq")
    const uploadRxWidget = widgets.find((widget) => widget.type === "upload_rx")

    // If both "faq" and "upload_rx" widgets exist, move the cta from "faq" to "upload_rx"
    if (faqWidget && uploadRxWidget) {
        uploadRxWidget.faqCta = faqWidget.cta

        // Remove the "faq" widget from the widgets array
        output.widgets = widgets.filter((widget) => widget.type !== "faq")
    }

    return output
}
